<template>
    <div class="">
        <div class="parallax-5 behind-text"></div>
         <div class="wrapper top-nav">

            <div class="branding on-the-top">
                <a href="/" rel="home"><img width="155" class="logo" src="/images/logo.png"></a>
            </div>

            <nav class="navigation column">
                <ul class="menu">
                    

                    <li class="menu-item  on-the-top">
                        <a href="/">Home</a>
                    </li>

                    <li v-if="!user & !isOwner" class="menu-item  on-the-top">
                        <a href="/registerbuilding">Register</a>
                    </li>

                    <li>
                        <v-row align="center">
                            <v-menu
                                v-model="value"
                                :disabled="disabled"
                                :absolute="absolute"
                                :open-on-hover="openOnHover"
                                :close-on-click="closeOnClick"
                                :close-on-content-click="closeOnContentClick"
                                :offset-x="offsetX"
                                :offset-y="offsetY"
                                >
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        class="text-capitalize font-weight-bold"
                                        v-ripple="{ class: 'transparent--text' }" variant="text"
                                        dark
                                        v-bind="props">
                                        Careers
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(item, index) in items"
                                        :key="index"
                                        :to="item.link"
                                        >
                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-row>
                    </li>

                    <li class="menu-item last  on-the-top">
                        <router-link v-if="!user" :to="{ name: 'login'}">Platform</router-link>
                        <router-link v-else-if="isOwner" :to="{ name: 'propertiesowner'}">Platform</router-link>
                        <router-link v-else  :to="{ name: 'buildings'}">Platform</router-link>
                    </li>

                </ul>
            </nav>
        </div>
        <div class="row">
            <div class='col-12 col-md-11 col-lg-8 col-md-offset-2'  id='loginDiv' style="padding:50px; margin-top:35px; margin-bottom:35px">
                <div class="row">
                    <div class="col-12">
                        <div style='padding:40px' class='col-12'>
                            <h1 style='font-weight:bold; font-size:25px; text-align:center; margin-top:-45px; margin-bottom:40px; padding:30px'>Web developer position</h1>
                            <h3>Η εταιρεία prolendar LTD <br> με έδρα τη Λεμεσό ζητά να προσλάβει</h3>  
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-6">                
                        <h4 style="margin-top:30px;">Requirements</h4>    
                        <ul>
                            <li>
                                <i class="fas fa-arrow-right"></i> Bsc in Computer Science or related field
                            </li>
                        </ul>
                        <h4 style="margin-top:30px;">Required Experience</h4>
                        <ul>
                            <li><i class="fas fa-arrow-right"></i> PHP</li> 
                            <li><i class="fas fa-arrow-right"></i> MVC frameworks</li>
                            <li><i class="fas fa-arrow-right"></i> Database engineering and design skills (MySQL)</li>
                            <li><i class="fas fa-arrow-right"></i> Javascript</li>
                            <li><i class="fas fa-arrow-right"></i> CSS3</li>
                            <li><i class="fas fa-arrow-right"></i> Bootstrap</li>
                            <li><i class="fas fa-arrow-right"></i> Api Integration</li>
                            <li><i class="fas fa-arrow-right"></i> Bitbucket</li>
                        </ul>
                        <h4 style="margin-top:30px;">Other beneficial tech skills</h4>
                        <ul>
                            <li><i class="fas fa-arrow-right"></i> Experience in frontend javascript framework (Vuejs, React)</li>
                            <li><i class="fas fa-arrow-right"></i> UI/UX</li>
                            <li><i class="fas fa-arrow-right"></i> C#</li>
                            <li><i class="fas fa-arrow-right"></i> Xamarin Forms</li>
                        </ul>
                        <h4 style="margin-top:30px;">Other Skills</h4>
                        <ul>                              
                            <li><i class="fas fa-arrow-right"></i> Communication skills</li>
                            <li><i class="fas fa-arrow-right"></i> Excellent command of the English language</li>
                            <li><i class="fas fa-arrow-right"></i> Hardworking</li>
                            <li><i class="fas fa-arrow-right"></i> Work under pressure</li>
                            <li><i class="fas fa-arrow-right"></i> Attention to detail</li>
                            <li><i class="fas fa-arrow-right"></i> High level of motivation</li>   
                        </ul>
                    </div>

                    <div class="col-12 col-sm-6" >
                        <table>
                            <tr style="border-bottom:1px solid black"><td style="margin-bottom:-10px" colspan="2"><h3>Job details</h3></td></tr>
                            <tr><td><i class="far fa-clock"></i></td><td style='font-weight:bold'><h4>Type</h4></td></tr>
                            <tr style='padding-top:0px'><td style='width:25px'></td><td>Full-time</td></tr>
                            <tr><td><i class="fas fa-map-marker-alt"></i></td><td style='font-weight:bold'><h4>Location</h4></td></tr>
                            <tr style='padding-top:0px'><td></td><td>Limassol, Cyprus</td></tr>
                            <tr><td><i class="fas fa-home"></i></td><td style='font-weight:bold'><h4>Remote work possible</h4></td></tr>
                            <tr style='padding-top:0px'><td></td><td>Yes</td></tr>
                            <tr><td><i class="far fa-edit"></i></td><td style='font-weight:bold'><h4>Qualifications</h4></td></tr>
                            <tr style='padding-top:0px'><td></td><td>Bsc in Computer Science</td></tr>
                        </table>

                        <button style='margin-top:32px; width: 100%' class='btn btn-edit' data-toggle="collapse" data-target="#demo">I'm interested</button>

                        <div id="demo" class="collapse">
                            <div
                            class="form-group"
                            style="padding-left: 15px; padding-right: 15px; margin-top:23px"
                            >
                            <strong>Full Name: *</strong>
                            <input
                                type="text"
                                v-model="fullName"
                                placeholder='Full Name'
                                class="form-control"
                            />
                            <div v-if="!fullName && submitted" class="invalid">Please provide a name.</div>
                            </div>

                            <div
                            class="form-group"
                            style="padding-left: 15px; padding-right: 15px;"
                            >
                            <strong>Email: *</strong>
                            <input
                                type="email"
                                v-model="email"
                                placeholder='Email'
                                class="form-control"
                            />
                            <div v-if="!email && submitted || !emailIsValid && submitted" class="invalid">Please provide a valid email.</div>
                            </div>

                            <div
                            class="form-group"
                            style="padding-left: 15px; padding-right: 15px;"
                            >
                            <strong>Phone number:</strong>
                            <input
                                type="number"
                                style='width:100%'
                                v-model="phone"
                                placeholder='Phone Number'
                                class="form-control"
                            />
                            </div>

                            <div class="form-group" style="padding-left: 15px; padding-right: 15px;">
                                <strong>Resume: *</strong>
                                <input type="file" @change="processFile($event)" class="custom-file-input" id="resumeFile">
                                <div
                                    v-if="resumeFile==false && submitted"
                                    class="invalid"
                                >Attach your resume to proceed.</div>
                            </div>
                            <div class="form-check" style="margin-left:15px">
                                <input type="checkbox" class="form-check-input" v-model="agreement" />
                                <label
                                    style="margin-top:10px; margin-left:10px; color:#2C2C2C"
                                    class="form-check-label"
                                    for="agreement"
                                    >I agree with <a href="javascript:void(0);" @click="showModalTerms()"
                                    >Terms and Conditions</a>

                                    <modal
                                        :scrollable="true"
                                        name="terms-and-conditions"
                                        @before-open="beforeOpen"
                                        height="auto"
                                        :minHeight="800"
                                        width="80%"
                                    >
                                        <div class="" id="termsModal" role="dialog">
                                        <div class="">
                                            <!-- Modal content-->
                                            <terms-and-conditions />
                                        </div>
                                        </div>
                                    </modal>
                                </label>
                                <div
                                    v-if="agreement==false && submitted"
                                    class="invalid"
                                >Agree on Terms and Conditions to proceed.</div>
                            </div>

                            <div class="text-center">
                                <button
                                    type="submit"
                                    class="btn btn-edit"
                                    style="margin-top:15px; margin-right:5px; margin-bottom:15px; width:45%"
                                    @click="submitForm()"
                                >Submit</button>

                                <button @click="$router.go(-1)" style="width:45%" class="btn btn-primary">Cancel</button>
                                <!-- MODAL IS HERE -->
                                    <modal
                                        :scrollable="true"
                                        name="submissionFailure"
                                        @before-open="beforeOpen"
                                        height="auto"
                                        :minHeight="150"
                                        width="400"
                                        >
                                        <div class role="document" :message="message">
                                            <div class>
                                            <!-- Modal content-->
                                            <submissionFailure />
                                            </div>
                                        </div>
                                    </modal>

                                    <!-- MODAL FOR SUCCESS IS HERE -->
                                    <modal
                                        :scrollable="true"
                                        name="emptyModal"
                                        @before-open="beforeOpen"
                                        height="auto"
                                        :minHeight="150"
                                        width="400"
                                        >
                                        <div class role="document">
                                            <div class>
                                            <!-- Modal content-->
                                            <emptyModal
                                                :message="message"
                                            />
                                            </div>
                                        </div>
                                    </modal>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
        </div>
    </div>
</template>

<style scoped>
.on-the-top{
    z-index:1;
    margin-top:-10px
}
.behind-text{
    z-index: 0!important;
    margin-left:-12px;
    margin-top:-12px;

}
.v-btn::before {
    background-color: transparent;
    text-decoration: underline
}

.v-btn:hover {
    text-decoration: underline
}

.v-btn{
    margin-top:-16px;
    font-size: 17px!important;
    letter-spacing: .01em;
    width:80px
}
.invalid {
  color: #c7254e !important;
  font-size: 13px !important;
  text-align: left !important;
}
ul.a {
  list-style-type: circle!important
}
h5{
    font-weight: bold;
}
h4{
    font-weight: bold;
}
#loginDiv{
    margin: auto;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white;
    line-height: 2
}
#logoLoginPage{
    margin-top: -20px;
    display: block;
    margin-left: auto;
    margin-right: auto;    
}

h2{
    margin-top:-25px; 
    text-align:center; 
    font-size: 20px; 
    color: black; 
    font-style: bolder;
    
}
#footerLoginDiv{
    border-top: 1px solid rgb(182, 179, 179);
    height: 30px;
}
</style>



<script>
export default {
    data () {
        return {
            items: [
                { title: 'Web developer', link:'/careers/webdeveloper' },
                { title: 'Customer service & support officer', link:'/careers/customerservice'},
            ],
            disabled: false,
            absolute: false,
            openOnHover: false,
            value: false,
            closeOnClick: true,
            closeOnContentClick: true,
            offsetX: false,
            offsetY: true,
            fullName:'',
            email:'',
            phone:'',
            agreement:false,
            message: 'Form submitted sucessfully!',
            submitted:false,
            resumeFile:'',
            jobTitle:'Web Developer'
        }
    },
    methods: {
        processFile(event) {
            this.resumeFile = event.target.files[0]
        },
        showModalTerms: function () {
            this.$modal.show("terms-and-conditions");
        },
        submitForm: function(){            
            this.submitted = true;

            let formData = new FormData();
            formData.append('resumeFile', this.resumeFile);

            if (this.formIsValid){
                this.$http.post('/email/register', {
                    fullName: this.fullName,
                    email: this.email,
                    phone: this.phone,
                    jobTitle: this.jobTitle,
                    formData : this.formData
                }).then(() => {
                    this.submitted = false;
                    this.submissionSuccess();
                    this.clearForm();          
                }, () => {   
                    this.submissionFailure()
                })
            }
        },
        clearForm: function() {
            this.fullName='',
            this.email='',
            this.phone='',
            this.agreement=false,
            this.resumeFile=''
    
        },
        submissionFailure: function(){
            this.$modal.show('submissionFailure');
        },
        submissionSuccess: function(){
            this.$modal.show('emptyModal');
        },
    },
    computed:{
        formIsValid (){
            return this.fullName && this.email && this.agreement && this.resumeFile
        },
        emailIsValid: function () {
            if(this.email.includes('@')){
                return true
            }

            return false
        }
    }
    
}
</script>